export const RESERVE_OFFICE_PATH = '/home/reserve-office';
